import {internalLinkToHref} from '@/modules/foundation/sanity/link/query';
import {PortableText} from '@/modules/foundation/sanity/portable-text';

import {AreaList} from '../../components/area-list';
import {descriptionPortableTextOverrides} from '../../components/guidebook-list';

import type {AreaListAllFragment} from './query';

type Props = {
	data: AreaListAllFragment;
	fullWidth?: boolean;
	anchorHeadings?: boolean;
	insideToc?: boolean;
};

export const AreaListAllContainer = ({data, fullWidth, anchorHeadings, insideToc}: Props) => {
	const {
		description,
		heading,
		contentBlockOptions,
		bankArea,
		collectionArea,
		insuranceArea,
		filter,
	} = data;

	const listItems = [];

	switch (filter) {
		case 'insurance-frontpage':
			if (insuranceArea) {
				listItems.push(...insuranceArea);
			}
			break;
		case 'bank-frontpage':
			if (bankArea) {
				listItems.push(...bankArea);
			}
			break;
		case 'collection-frontpage':
			if (collectionArea) {
				listItems.push(...collectionArea);
			}
			break;
		default:
			if (insuranceArea && bankArea && collectionArea) {
				listItems.push(...insuranceArea, ...bankArea, ...collectionArea);
			}
			break;
	}

	return (
		<AreaList
			heading={heading}
			description={
				description && description.length > 0 ? (
					<PortableText
						value={description}
						overrideClassNames={descriptionPortableTextOverrides}
					/>
				) : null
			}
			listItems={listItems?.map((item) => ({
				title: item.title ?? '',
				href: internalLinkToHref(item._type, item.slug ?? ''),
				_key: item._id,
				icon: item.icon ?? undefined,
			}))}
			anchorHeadings={anchorHeadings}
			options={{fullWidth, ...contentBlockOptions}}
			insideToc={insideToc}
		/>
	);
};
